import { render, staticRenderFns } from "./NoteSeveritySelect.vue?vue&type=template&id=44246383&"
import script from "./NoteSeveritySelect.vue?vue&type=script&lang=js&"
export * from "./NoteSeveritySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports